/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 85856:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(53550);

/***/ }),

/***/ 38472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var config = __webpack_require__(58501);
var VideoLazy = function VideoLazy(_ref) {
  var videoId = _ref.videoId,
    src = _ref.src,
    deviceType = _ref.deviceType;
  return /*#__PURE__*/_jsx("div", {
    className: "video__placeholder",
    style: {
      height: config[deviceType].height,
      width: '100%'
    }
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "video__container"
  }, void 0, /*#__PURE__*/_jsx("iframe", {
    className: "video",
    src: src,
    allowFullScreen: true,
    frameBorder: "0",
    title: videoId,
    height: config[deviceType].height
  })));
};
module.exports = VideoLazy;

/***/ }),

/***/ 58501:
/***/ ((module) => {

module.exports = {
  mobile: {
    height: 215
  },
  tablet: {
    height: 421
  },
  desktop: {
    height: 666
  }
};

/***/ }),

/***/ 93572:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var normalVariation = __webpack_require__(35778);
var vimeoVariation = __webpack_require__(81072);
var facebookVariation = __webpack_require__(98509);
module.exports = {
  normal: {
    component: normalVariation
  },
  vimeo: {
    component: vimeoVariation
  },
  facebook: {
    component: facebookVariation
  }
};

/***/ }),

/***/ 98509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _div, _div2, _Script, _Script2;
__webpack_require__(90444);
__webpack_require__(11076);
var React = __webpack_require__(16689);
var Script = __webpack_require__(63898);
var Facebook = function Facebook(_ref) {
  var videoId = _ref.videoId,
    title = _ref.title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  var videoLink = "https://www.facebook.com/facebook/videos/".concat(videoId, "/");
  return /*#__PURE__*/_jsx(React.Fragment, {}, void 0, _div || (_div = _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
    id: "fb-root"
  }))), _Script || (_Script = _Script2 || (_Script2 = /*#__PURE__*/_jsx(Script, {
    priority: 200,
    src: "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2"
  }))), /*#__PURE__*/_jsx("div", {
    className: "fb-video",
    "data-href": videoLink,
    "data-show-text": false,
    "data-lazy": "true"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "fb-xfbml-parse-ignore"
  }, void 0, /*#__PURE__*/_jsx("blockquote", {
    cite: videoLink
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: videoLink
  }, void 0, title), description && /*#__PURE__*/_jsx("p", {}, void 0, description)))));
};
Facebook.defaultProps = {
  description: ''
};
module.exports = Facebook;

/***/ }),

/***/ 35778:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var VideoLazy = __webpack_require__(38472);
var Normal = function Normal(_ref) {
  var videoId = _ref.videoId,
    deviceType = _ref.deviceType;
  return /*#__PURE__*/_jsx(VideoLazy, {
    videoId: videoId,
    src: "https://www.youtube.com/embed/".concat(videoId),
    deviceType: deviceType
  });
};
module.exports = Normal;

/***/ }),

/***/ 81072:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var VideoLazy = __webpack_require__(38472);
var Vimeo = function Vimeo(_ref) {
  var videoId = _ref.videoId,
    deviceType = _ref.deviceType;
  var src = "https://player.vimeo.com/video/".concat(videoId);
  return /*#__PURE__*/_jsx(VideoLazy, {
    videoId: videoId,
    src: src,
    deviceType: deviceType
  });
};
module.exports = Vimeo;

/***/ }),

/***/ 53550:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
var React = __webpack_require__(16689);
var _require = __webpack_require__(16689),
  useContext = _require.useContext;
var Variations = __webpack_require__(6996);
var _require2 = __webpack_require__(31901),
  LandingContext = _require2.LandingContext;
var schema = __webpack_require__(93572);
var Video = function Video(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _useContext = useContext(LandingContext),
    components = _useContext.landingData.components,
    _useContext$landingCo = _useContext.landingConfig,
    osVersion = _useContext$landingCo.osVersion,
    osName = _useContext$landingCo.osName,
    deviceType = _useContext$landingCo.deviceType;
  var json = component || components[index];
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_jsx("section", {
        className: "section__video"
      }, void 0, /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread(_objectSpread({}, json.data), {}, {
        osName: osName,
        osVersion: osVersion,
        deviceType: deviceType
      })));
    }
  });
};
Video.defaultProps = {
  component: null
};
module.exports = Video;

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 11076:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.symbol.description.js");

/***/ }),

/***/ 90444:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.symbol.js");

/***/ }),

/***/ 63898:
/***/ ((module) => {

"use strict";
module.exports = require("frontend-script");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(85856);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map